import React, { useRef } from 'react';
import PhoneValidation from './PhoneValidation';
import '../styles/PhoneValidation.css';

function formatPhoneNumber(inputValue) {
  const phoneNumber = inputValue.replace(/\D/g, '').slice(0, 10);

  if (phoneNumber.length >= 6) {
    return `(${phoneNumber.slice(0, 3)})-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
  }
  if (phoneNumber.length >= 3) {
    return `(${phoneNumber.slice(0, 3)})-${phoneNumber.slice(3)}`;
  }
  if (phoneNumber.length > 0) {
    return `(${phoneNumber}`;
  }
  return phoneNumber;
}

const PhoneInput = ({ value, onChange, onValidationChange, placeholder, required, id, name }) => {
  const inputRef = useRef(null);
  const displayValue = formatPhoneNumber(value || '');

  const getCursorPosition = (newFormatted, oldFormatted, cursorPos) => {
    const oldDigits = oldFormatted.replace(/\D/g, '');
    const newDigits = newFormatted.replace(/\D/g, '');

    if (newDigits.length > oldDigits.length) {
      return newFormatted.length;
    }

    if (newDigits.length < oldDigits.length) {
      const digitsBeforeCursor = oldFormatted.slice(0, cursorPos).replace(/\D/g, '').length;
      let newCursorPos = 0;
      let digitCount = 0;

      for (let i = 0; i < newFormatted.length; i++) {
        if (/\d/.test(newFormatted[i])) {
          digitCount++;
          if (digitCount === digitsBeforeCursor) {
            newCursorPos = i + 1;
            break;
          }
        }
      }

      return Math.min(newCursorPos, newFormatted.length);
    }

    return cursorPos;
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const cursorPos = e.target.selectionStart;
    const oldFormattedValue = displayValue;
    const phoneNumber = inputValue.replace(/\D/g, '').slice(0, 10);
    const formatted = formatPhoneNumber(phoneNumber);

    onChange({
      ...e,
      target: {
        ...e.target,
        name: e.target.name,
        value: formatted,
      },
    });

    setTimeout(() => {
      if (inputRef.current) {
        const newCursorPos = getCursorPosition(formatted, oldFormattedValue, cursorPos);
        inputRef.current.setSelectionRange(newCursorPos, newCursorPos);
      }
    }, 0);
  };

  const handleKeyDown = (e) => {
    if (
      [8, 9, 27, 46, 37, 38, 39, 40].includes(e.keyCode) ||
      (e.keyCode === 65 && e.ctrlKey) ||
      (e.keyCode === 67 && e.ctrlKey) ||
      (e.keyCode === 86 && e.ctrlKey) ||
      (e.keyCode === 88 && e.ctrlKey)
    ) {
      return;
    }

    if ((e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  };

  return (
    <div className="phone-input-container">
      <input
        ref={inputRef}
        type="tel"
        id={id}
        name={name}
        value={displayValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        required={required}
        className="phone-input"
        maxLength="14"
      />
      <PhoneValidation phone={displayValue} onValidationChange={onValidationChange} />
    </div>
  );
};

export default PhoneInput;
